module.exports = __webpack_public_path__ + "static/media/truck7.e6bae267.jpg";